export default "__VITE_ASSET__DmdThc8J__"